import React from "react";

const faqs = [
  {
    q: "Who is LeadKey AI for?",
    a: "Business owners and new real estate agents who want 24/7 coverage, faster response times, and better conversion without hiring a full-time receptionist.",
  },
  {
    q: "Can it book appointments on my calendar?",
    a: "Yes. Connect your calendar and we’ll auto-book showings and consults with confirmations and reminders.",
  },
  {
    q: "Will it handle after-hours calls and messages?",
    a: "Absolutely. Calls, web chat, SMS, and Facebook Messenger can be answered any time—no more missed opportunities.",
  },
  {
    q: "What about spam and bots?",
    a: "We score and filter low-quality inquiries so your pipeline stays clean and you stay focused on real buyers and sellers.",
  },
  {
    q: "Is it fair-housing safe?",
    a: "Yes. We add guardrails to keep replies compliant and unbiased. You control approved answers and sources.",
  },
  {
    q: "How do I get started?",
    a: "Join the waitlist above. We’ll reach out with setup steps, including connecting your phone/chat and adding your FAQs.",
  },
];

export default function FAQ() {
  return (
    <section className="lk-section lk-faq">
      <div className="lk-container">
        <h2>FAQs</h2>
        <div className="lk-faq-grid">
          {faqs.map((f) => (
            <div className="lk-faq-item" key={f.q}>
              <h3>{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
